import { render, staticRenderFns } from "./time-table.vue?vue&type=template&id=04c6873e"
import script from "./time-table.vue?vue&type=script&lang=js"
export * from "./time-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports